"use client"

import axios from "../api/axios"
import { useNavigate } from "react-router-dom"
import { LogOut } from "lucide-react"

function LogoutButton() {
  const navigate = useNavigate()

  const handleLogout = async () => {
    try {
      await axios.post("/api/logout")
      localStorage.clear()
      sessionStorage.clear()
      navigate("/")
      window.location.reload()
    } catch (err) {
      console.error("Logout failed:", err.response?.data || err.message)
    }
  }

  return (
    <button
      onClick={handleLogout}
      className="flex items-center space-x-2 bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg font-medium transition-colors shadow-sm"
    >
      <LogOut size={16} />
      <span className="hidden sm:inline">Logout</span>
    </button>
  )
}

export default LogoutButton
